function initStickyAddToCart() {
  const bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;

  const anchor = document.getElementById(bar.getAttribute('data-anchor'));
  if (!anchor) return;

  const observer = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        bar.classList.remove('sticky-atc--visible');
      } else if (entry.boundingClientRect.top < 0) {
        bar.classList.add('sticky-atc--visible');
      } else {
        bar.classList.remove('sticky-atc--visible');
      }
    },
    { threshold: 0 }
  );

  observer.observe(anchor);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStickyAddToCart);
} else {
  initStickyAddToCart();
}

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initStickyAddToCart);
}
